import { apolloClient } from "@/plugins/vue-apollo.js";

const updateUnitType = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/property/api/mutations/unitType/update_unit_type.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/property/api/queries/unitType/unit_type_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        let allUnitType = store.readQuery(query);
        // debugger
        const findIndex = allUnitType.getUnitTypes.unitTypes.findIndex(
          (item) => item._id === data.updateUnitType._id
        );
        findIndex !== -1 &&
          allUnitType.getUnitTypes.unitTypes.splice(
            findIndex,
            1,
            data.updateUnitType
          );
        store.writeQuery({
          ...query,
          data: allUnitType,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateUnitType };
